import React from 'react';
import './sec5-p3.css'
import { supabase } from '../supabase';
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import pic45 from '../assets/pic45.png'
import pic46 from '../assets/pic46.png'
import Input from '../components/common/input';
import Cta from '../components/common/cta';
import pic47 from'../assets/pic47.png'
import pic48 from'../assets/pic48.png'
import pic49 from'../assets/pic49.png'
import Popup from '../components/common/popup';
import Errormsginput from '../components/common/errormsginput';
const Sec5p3 = ({ bookingData, setBookingData, errors, setErrors }) => {


const [selectedPayment, setSelectedPayment] = useState("card");

const [showPopup, setShowPopup] = useState(false);
const [popup, setPopup] = useState([]);

const closePopup = () => {
  setShowPopup(false);
};


    const [headers, setheaders]= useState([]);

        useEffect(() => {
        const getheaders = async()=>{
            const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
        setheaders(res.data);
        }
        getheaders();
        }, []);






const price = bookingData.ticket?.price || 0;
const subtotal = price * bookingData.quantity;
const taxes = 200;
const total = subtotal + taxes;






const [paymentData, setPaymentData] = useState({
  cardName: "",
  cardNumber: "",
  expiry: "",
  cvv: ""
});


const [agreed, setAgreed] = useState(false);







const handleBooking = async () => {
    const newErrors = {};
     let hasErrors = false;

        if (!bookingData.user.name) {
        newErrors.name = "Name is required"; hasErrors = true;}

        if (!bookingData.user.email) {
        newErrors.email = "Email is required";  hasErrors = true;} else if (!/\S+@\S+\.\S+/.test(bookingData.user.email)) {
        newErrors.email = "Invalid email format"; hasErrors = true;}

        if (!bookingData.user.phone) { newErrors.phone = "Phone is required";   hasErrors = true;}

        if (!bookingData.date) { newErrors.date = "Please select a date";   hasErrors = true;}

        if (!paymentData.cardName)   { newErrors.cardName   = "Card name is required";  hasErrors = true; }
        if (!paymentData.cardNumber) { newErrors.cardNumber = "Card number is required"; hasErrors = true; }

        if (!paymentData.expiry)     { newErrors.expiry     = "Expiry date is required"; hasErrors = true; }
        if (!paymentData.cvv)        { newErrors.cvv        = "CVV is required";         hasErrors = true; }



            if (!agreed) { 
                newErrors.agreed = "You must agree to terms"; hasErrors = true; }

        setErrors(newErrors);


        if (hasErrors) {
                alert("Please fill in all required fields before submitting.");
                return;
            }

 const { data: userData, error: userError } = await supabase
    .from("users")
    .insert([{
      user_name: bookingData.user.name,
        user_email: bookingData.user.email,
      phone: bookingData.user.phone,
        job_title: bookingData.user.job_title,
      company_name: bookingData.user.company_name,
      address: bookingData.user.address,
    }])

    .select()
    .single();


  if (userError) {
    console.error(userError);
    alert("Error");
    return; 
  }

 const { error: bookingError } = await supabase
    .from("bookings")
    .insert([{
      user_id: userData.id,
      ticket_id: bookingData.ticket.id,
         booking_date: bookingData.date,
 event_id: bookingData.eventId,
      quantity: bookingData.quantity,
      total_price: total,
      status: "pending"
    }]);


    
        if (bookingError) {
    console.error(bookingError);
    alert("Error creating booking");
    return; 
  }

setShowPopup(true);


}




useEffect(() => {
const getpopup = async()=>{
    const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;

setPopup(res.data);
}
getpopup();
}, []);
















 const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);
















    return (  
        <section className='sec5-page3' ref={secRef}>
            <section className='container-cards-sec5-p3'>
                    <section className='big-cont-sec5--p3'>
                        <article className='main-cont-sec5-p3'>
                            <h1 className='header-sec3-p3'>{headers?.[16]?.header}</h1>
                            <section className='part2-sec5-p3'>
                                    <section className='right-container-sec5-p3'>
                                        <section className='box1-sec5-p3'>
                                                <h2 className='subheaders-sec5-p3'>{headers?.[16]?.sub_title}</h2>
                                                <form className='availablepaymentcardcontainer-sec5-p3'>
                                                    <h3 className='smaller-sub-header-sec5-p3'>Available Payment</h3>
                                                    <section className='container-cards-selection-sec5-p3'>

                                                        <button
                                                        className={`button-card-sec5-p3 ${selectedPayment === "card" ? "active" : ""}`}
                                                        onClick={(e) => {
                                                        e.preventDefault();
                                                        setSelectedPayment("card");
                                                        }}
                                                        >
                                                            <img src={pic45} alt='credit card'></img>
                                                            <h3 className='card-text-sec5-p3'>Credit Card</h3>
                                                        </button>

                                                        <button
                                                        className={`button-card-sec5-p3 ${selectedPayment === "paypal" ? "active" : ""}`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedPayment("paypal");
                                                            }}
                                                        
                                                        >
                                                            <img src={pic46} alt='paypal'></img>
                                                            <h3 className='card-text-sec5-p3'>Paypal</h3>
                                                        </button>

                                                    </section>
                                                </form>
                                        </section>



                                        <section className='box1-sec5-p3'>
                                                <h2 className='subheaders-sec5-p3'>{headers?.[16]?.sub_title2}</h2>
                                                <section className='availablepaymentcardcontainer-sec5-p3'>

                                                    <section className='conatinerr-form-sec5-p3'>
                                                        <form className='container2-cards-selection-sec5-p3'>
                                                            <Input title='Card Placeholder' 
                                                                type='text'
                                                                        placeholder='Enter placeholder'
                                                                          onChange={(e) =>
                                                                    setPaymentData(prev => ({
                                                                    ...prev,
                                                                    cardName: e.target.value
                                                                    }))
                                                                } />
                                                                <Errormsginput message={errors.cardName} />

                                                            <Input title='Card Number' 
                                                                type='text'
                                                                        placeholder='Enter Number'
                                                                        onChange={(e) =>
                                                                            setPaymentData(prev => ({
                                                                            ...prev,
                                                                            cardNumber: e.target.value
                                                                            }))
                                                                        } />
                                                                 <Errormsginput message={errors.cardNumber} />

                                                            <fieldset className='row-inputtt-sec5-p3'>
                                                                <fieldset className='colum--input-payment-details-with-error'>
                                                                <Input title='Expire Date' 
                                                                    type='text'
                                                                            placeholder='MM/YY'
                                                                            onChange={(e) =>
                                                                    setPaymentData(prev => ({
                                                                        ...prev,
                                                                        expiry: e.target.value
                                                                    }))
                                                                    } />
                                                                    <Errormsginput message={errors.expiry} />
                                                                </fieldset>

                                        <fieldset className='colum--input-payment-details-with-error'>
                                                                <Input title='CVV' 
                                                                    type='text'
                                                                    placeholder='Enter CVV'
                                                                     onChange={(e) =>
                                                                        setPaymentData(prev => ({
                                                                            ...prev,
                                                                            cvv: e.target.value
                                                                        }))
                                                                        } />
                                                                    <Errormsginput message={errors.cvv} />
                                                                    </fieldset>
                                                            </fieldset>
               
                                                        </form>
                                                         <fieldset className='colum--input-payment-details-with-error'>
                                                          <label className="custom-checkbox" onChange={(e) => setAgreed(e.target.checked)}>
                                                            <input type="checkbox"  />
                                                            <span className="checkmark"></span>
                                                            I agree to the terms
                                                            </label>

                                                            <Errormsginput message={errors.agreed} /> 
                                                        </fieldset>



                                                        <Cta title={headers?.[16]?.cta}  onClick={handleBooking} />

                                                    </section>
                                                </section>
                                        </section>

                              </section>



                                    <section className='left-container-sec5-p3'>
                                        <section className='box1-sec5-p3'>
                                                 <h2 className='subheaders-sec5-p3'>{headers?.[16]?.subtitle3}</h2>
                                                 <article className='form-right-part-sec5-p3'>
                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <h2 className='name-right-part-sec5-p2'>{bookingData.user.name || "Your Name"}</h2>
                                                        <h2 className='email-right-part-sec5-p2'>{bookingData.user.email || "Your Email"}</h2>
                                                        <h2 className='email-right-part-sec5-p2'>{bookingData.user.phone || "Your Phone"}</h2>
                                                    </article>

                                                    <div className='line-sec5-p2'></div>

                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <article className='iconplustext-sec5-p2'>
                                                            <img src={pic47} alt='ticket'></img>
                                                            <h2 className='midd-text-right-part-sec5-p3'> {bookingData.quantity} {bookingData.ticket?.subheader }</h2>
                                                        </article>
                                                        <article className='iconplustext-sec5-p2'>
                                                            <img src={pic48} alt='date'></img>
                                                            <h2 className='midd-text-right-part-sec5-p3'>{bookingData.date ? new Date(bookingData.date).toDateString() : "Select a date"}</h2>
                                                        </article>
                                                    </article>

                                                    <div className='line-sec5-p2'></div>

                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <article className='subtotal-container-sec5-p2'>
                                                            <h2 className='subtotal-text-sec5-p3'>Subtotal</h2>
                                                            <h2 className='numberrr-text-sec5-p3'>{subtotal}EGP</h2>
                                                        </article>
                                                        <article className='subtotal-container-sec5-p2'>
                                                            <h2 className='subtotal-text-sec5-p3'>Taxes</h2>
                                                            <h2 className='numberrr-text-sec5-p3'>{taxes} EGP</h2>
                                                        </article>
                                                    </article>

                                                     <div className='line-sec5-p2'></div>                                                   

                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <article className='subtotal-container-sec5-p2'>
                                                            <h2 className='subtotal-text-sec5-p3'>Total</h2>
                                                            <h2 className='totalnumberrcost'>{total} EGP</h2>
                                                        </article>
                                                    </article>


                                                 </article>
                                        </section>
                                    </section>




                            </section>
                        </article>
                    </section>
            </section>
            {showPopup && (
  <Popup
    to="/"
    onClose={closePopup}
    img={popup?.[1]?.image}
     alt={popup?.[1]?.icon_alt} 
    header={popup?.[1]?.title}
    para={popup?.[1]?.paragraph}
    title={popup?.[1]?.cta_text_primary}
  />
)}
      
        </section>
    );
}
 
export default Sec5p3;